module.exports = __webpack_public_path__ + "media/src/images/favicons/mstile-150x150-7ef2d3784e93a8d88b2dabd4ec94e758.png";